import * as React from 'react';
import { SxProps, Typography } from '@mui/material';
import { memo } from 'react';

import { FieldProps, useRecordContext } from 'react-admin';
import { City } from '../types';

interface Props extends FieldProps<City> {
    size?: string;
    sx?: SxProps;
}

const FullNameField = (props: Props) => {
    // const { size } = props;
    const record = useRecordContext<City>();
    return record ? (
        <Typography
            variant="body2"
            display="flex"
            flexWrap="nowrap"
            alignItems="center"
            component="div"
            sx={props.sx}
        >
            {record.id} / {record.title}
        </Typography>
    ) : null;
};

FullNameField.defaultProps = {
    source: 'title' as const,
    label: 'resources.cities.fields.title',
};

export default memo<Props>(FullNameField);
